export default "__VITE_ASSET__Bbv2uxy6__"